module.exports = __webpack_public_path__ + "static/persosa-og-7172c53c0f2f1b2ed3e75193b9f5b217.jpg";